import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-grid__cell gfu-1of1" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h2 _ttu" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.Resources.SubscriptionManagement.AdfoundNotificationHeader), 1 /* TEXT */),
        _createVNode(_component_option_field, {
          modelValue: _ctx.model.performanceMarketingDailyReport,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = $event => ((_ctx.model.performanceMarketingDailyReport) = $event)),
            $options.onPerformanceMarketingDailyReportNotificationPreferenceChange
          ],
          "first-column-width": 8,
          options: $options.basePreferenceOptions,
          "display-name": _ctx.Resources.SubscriptionManagement.PerformanceMarketingDailyReportFieldLabel,
          name: "model.performanceMarketingDailyReport",
          layout: "columns",
          class: "_mb-3",
          description: _ctx.Resources.SubscriptionManagement.PerformanceMarketingDailyReportFieldDescription,
          "data-qa": "adfound-notifications:PerformanceMarketingDailyReport"
        }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]),
        _createVNode(_component_option_field, {
          modelValue: _ctx.model.performanceMarketingRecommendation,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = $event => ((_ctx.model.performanceMarketingRecommendation) = $event)),
            $options.onPerformanceMarketingRecommendationNotificationPreferenceChange
          ],
          "first-column-width": 8,
          options: $options.basePreferenceOptions,
          "display-name": _ctx.Resources.SubscriptionManagement.PerformanceMarketingRecommendationFieldLabel,
          name: "model.performanceMarketingRecommendation",
          layout: "columns",
          class: "_mb-3",
          description: _ctx.Resources.SubscriptionManagement.PerformanceMarketingRecommendationFieldDescription,
          "data-qa": "adfound-notifications:PerformanceMarketingRecommendation"
        }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}